import { withStyles } from '@material-ui/core';
import InvoiceDetailsTable from './InvoiceDetailsTable';
import styles from './styles';

export default withStyles(styles)(InvoiceDetailsTable);
